import { Sparkles } from "lucide-react";

const SIZES = {
  sm: { box: "h-10 w-10 sm:h-12 sm:w-12 rounded-xl", text: "text-lg sm:text-xl", sparkle: "h-3 w-3" },
  md: { box: "h-14 w-14 rounded-2xl", text: "text-2xl", sparkle: "h-3.5 w-3.5" },
  lg: { box: "h-24 w-24 sm:h-28 sm:w-28 rounded-[1.75rem]", text: "text-4xl sm:text-5xl", sparkle: "h-5 w-5" },
};

export const LogoMark = ({ size = "md" }) => {
  const s = SIZES[size];
  return (
    <div
      data-testid="logo-mark"
      className={`relative flex items-center justify-center ${s.box} bg-gradient-to-br from-[#101D42] via-[#0A1128] to-[#123057] ring-2 ring-sky-400/50 shadow-lg shadow-sky-500/25`}
    >
      <span className={`font-display ${s.text} font-extrabold italic tracking-tighter leading-none`}>
        <span className="text-white">E</span>
        <span className="text-sky-400">N</span>
      </span>
      <Sparkles className={`absolute -top-1.5 -right-1.5 ${s.sparkle} text-cyan-300`} />
    </div>
  );
};
